import { makeAutoObservable } from 'mobx'
import { logger } from 'shared/lib'
import { RequestCancelAxios } from 'shared/api/lib'
import { bannerStore, EnumAlertBannerVariant } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { PhoneApi } from 'entities/Phone'
import { NumbersPath } from 'pages/settings/pages/numbers/route/numbersPath'

export class LandlineBannerStore {
  private _idsCacheMap: Map<number, number> = new Map()
  private _cancelRequest = new RequestCancelAxios()
  private _banner_id = 'landline_banner'

  constructor(readonly entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  init = () => {
    this._fetchNumbers()
  }

  initBanner = () => {
    if (this.show) {
      bannerStore.add({
        id: this._banner_id,
        alert: {
          title: "Your landline setup isn't complete.",
          variant: EnumAlertBannerVariant.Info,
          ariaLabel: 'landline_banner',
        },
        action: {
          text: 'Finish setup',
          onAction: () => {
            this.onAction(true)
          },
        },
        actionClose: {
          onAction: () => {
            this.onAction(false)
          },
          showCloseBtn: true,
        },
      })
    } else {
      bannerStore.remove(this._banner_id)
    }
  }

  private _fetchNumbers = async () => {
    try {
      this._idsCacheMap.clear()
      this._cancelRequest.init()

      const { data } = await PhoneApi.getUnassignedNumbers(
        {
          page: 1,
          limit: 500,
          withLandline: true,
        },
        {
          cancelToken: this._cancelRequest.token,
        }
      )

      data.data.forEach((item) => {
        if (item.landline) {
          this._idsCacheMap.set(item.id, item.id)
          this.entities.numbersStore.addItem(item)
        }
      })
    } catch (e) {
      logger.error(e)
    }
  }

  dispose = () => {
    this._cancelRequest.reset()
    bannerStore.remove(this._banner_id)
    this._idsCacheMap.forEach((id) => {
      this.entities.numbersStore.deleteItem(id)
    })
  }

  onAction = (is_redirect: boolean) => {
    bannerStore.remove(this._banner_id)

    if (is_redirect) {
      uiStore.changeRouteViaVue({
        path: `/${NumbersPath.root}`,
        query: '?tab=unassigned',
      })
    }

    this.dispose()
  }

  private get _hasIncomplete() {
    return this.entities.numbersStore.numbers.some((item) => {
      if (!item.landline) return false

      return item.landline.hasIncomplete
    })
  }

  get show() {
    return this._hasIncomplete
  }
}
